export default __webpack_public_path__ + "static/media/logo_yearn_watch_dark.e3636f70.svg";